import { useTranslation } from "react-i18next";
import { Box, Container, Flex, Text } from "@chakra-ui/react";

const SectionTitle = ({ children }) => (
    <Text
        fontWeight={700}
        fontSize={'18px'}
        lineHeight={'28px'}
        color={'#1E1517'}
        mt={'8px'}
    >
        {children}
    </Text>
);

const SectionParagraph = ({ children }) => (
    <Text
        fontWeight={400}
        fontSize={'15px'}
        lineHeight={'26px'}
        color={'#3B3033'}
    >
        {children}
    </Text>
);

const BulletList = ({ items }) => (
    <ul style={{ paddingLeft: '20px', margin: 0 }}>
        {items.map((item, idx) => (
            <li key={idx} style={{ fontWeight: 400, fontSize: '15px', lineHeight: '26px', color: '#3B3033', listStyleType: 'disc' }}>
                {item}
            </li>
        ))}
    </ul>
);

const About = () => {
    const { t } = useTranslation("about");

    const attendeesList = t('s2.list', { returnObjects: true })
        .split('\n')
        .filter(Boolean);

    const organizersList = t('s3.list', { returnObjects: true })
        .split('\n')
        .filter(Boolean);

    return (
        <>
            <Box w={'full'} fontFamily="body">
                <Container maxW={'7xl'} py={'64px'}>
                    <Flex flexDirection={'column'} gap={'8px'}>

                        {/* Nagłówek strony */}
                        <Text
                            fontWeight={700}
                            fontSize={'26px'}
                            lineHeight={'38px'}
                            color={'#1E1517'}
                            textAlign={'center'}
                            mb={'24px'}
                        >
                            {t('page_title')}
                        </Text>

                        {/* Separator */}
                        <Flex w={'full'} h={'1px'} bg={'#ECE4E4'} mb={'32px'} />

                        {/* Sekcje */}
                        <Flex gap={'32px'} flexDirection={'column'} w={'full'}>

                            {/* Sekcja 1: Czym jest Evenado? */}
                            <Flex flexDirection={'column'} gap={'12px'}>
                                <SectionTitle>{t('s1.title')}</SectionTitle>
                                <SectionParagraph>{t('s1.p1')}</SectionParagraph>
                                <SectionParagraph>{t('s1.p2')}</SectionParagraph>
                            </Flex>

                            {/* Sekcja 2: Dla uczestników */}
                            <Flex flexDirection={'column'} gap={'12px'}>
                                <SectionTitle>{t('s2.title')}</SectionTitle>
                                <SectionParagraph>{t('s2.p1')}</SectionParagraph>
                                <SectionParagraph>{t('s2.p2')}</SectionParagraph>
                                <BulletList items={attendeesList} />
                                <SectionParagraph>{t('s2.p3')}</SectionParagraph>
                            </Flex>

                            {/* Sekcja 3: Dla organizatorów */}
                            <Flex flexDirection={'column'} gap={'12px'}>
                                <SectionTitle>{t('s3.title')}</SectionTitle>
                                <SectionParagraph>{t('s3.p1')}</SectionParagraph>
                                <BulletList items={organizersList} />
                                <SectionParagraph>{t('s3.p2')}</SectionParagraph>
                            </Flex>

                        </Flex>

                    </Flex>
                </Container>
            </Box>
        </>
    );
};

export default About;
